import { createBrowserHistory } from 'history';

const appHistory = createBrowserHistory();
export default appHistory;
